define('apps/admin/views/modals/onboarding-start-over-modal',[
        'app',
        'njs!apps/admin/templates/includes/modals/_onboarding_start_over_modal(params:tmpl=admin/main/includes/modals/_onboarding_start_over_modal.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal__button--confirm": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
            },

            "template": template,

            "initialize": function(opts){
                this.model.set({
                    "showCancelButton": true,
                    "showOKButton": false
                });
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });
});

